<template>
  <fieldset v-bind="$attrs" class="govuk-fieldset" >
    <legend class="govuk-fieldset__legend">
      <slot name="legend" />
    </legend>
    <slot name="fields" />
  </fieldset>
</template>
